<template>
    <!-- breadCrumb -->
    <div class="bread_crumb">
        <div class="bread_crumb_inner">
            <a href="" class="home">홈</a>
            <a href="">디지털기부화환</a>
        </div>
    </div>
    <!-- //breadCrumb -->

    <main id="main">
        <div class="contents">
            <section class="hero" id="top">
            <h1>진심(眞心)을 전하는 '진심(陳心)'</h1>
            <p class="lead">블라썸로고스 ‘진심’은 장례·결혼 등 의미 있는 순간에 **조화 대신 기부**를 선택할 수 있게 하는 디지털화환 서비스입니다. 메시지는 현장 디스플레이에 송출되고, 기부는 도움이 필요한 곳으로 투명하게 전달됩니다.</p>
            </section>

            <section id="about" class="grid cols-3">
            <div class="card">
                <h3>꽃 대신 **의미**를</h3>
                <p class="muted">조화 구매를 줄이고, 같은 비용을 기부로 전환합니다. 애도의 마음·축하의 마음이 누군가의 내일을 밝힙니다.</p>
            </div>
            <div class="card">
                <h3>현장 **디스플레이 송출**</h3>
                <p class="muted">보내는 분의 이름과 메시지가 빈소·예식장 등 현장 스크린에 고운 화면으로 노출됩니다.</p>
            </div>
            <div class="card">
                <h3>**투명한 기부 흐름**</h3>
                <p class="muted">기부 내역은 기록·집계되어 보고 가능합니다. 파트너 기관과 함께 결과를 공유합니다.</p>
            </div>
            </section>

            <div class="divider"></div>

            <section id="how" class="grid cols-3">
            <div class="card">
                <h3>1) 선택</h3>
                <p class="muted">조화 대신 ‘진심’을 선택하고 온라인으로 메시지를 작성합니다.</p>
            </div>
            <div class="card">
                <h3>2) 송출</h3>
                <p class="muted">메시지가 현장 디스플레이에 노출됩니다. (모바일 확인 가능)</p>
            </div>
            <div class="card">
                <h3>3) 기부</h3>
                <p class="muted">금액은 지정된 공익처로 전달되고, 사후 보고로 투명하게 공유됩니다.</p>
            </div>
            </section>

            <section id="esg" class="grid cols-3" style="margin-top:18px;">
            <div class="stat">
                <div class="num">E</div>
                <div>조화 폐기물·소각 감소 → 탄소저감, 친환경 경조문화</div>
                <div class="chip">Zero-Waste</div>
                <div class="chip">Carbon-Lite</div>
            </div>
            <div class="stat">
                <div class="num">S</div>
                <div>기부 전환으로 사회적 약자 지원, 참여형 사회공헌</div>
                <div class="chip">Giving by Default</div>
                <div class="chip">Community Impact</div>
            </div>
            <div class="stat">
                <div class="num">G</div>
                <div>기부 흐름 기록·공유로 투명성 강화, 신뢰 기반 운영</div>
                <div class="chip">Transparency</div>
                <div class="chip">Impact Report</div>
            </div>
            </section>

            <section id="impact" class="grid cols-2" style="margin-top:18px;">
            <div class="card">
                <h3>임팩트 예시</h3>
                <p class="muted">화환 1건이 **아동 1명의 1주 식사**로 전환될 수 있습니다. 월 1,000건 참여 시 월 4,000만원 규모의 기금이 조성됩니다. (기관별 설정 가능)</p>
            </div>
            <div class="card">
                <h3>도입 장소</h3>
                <p class="muted">병원 장례식장, 교회·예식장, 추모·기념 행사, 기업 행사 등</p>
            </div>
            </section>

            <section id="faq" class="grid cols-2" style="margin-top:18px;">
            <div class="card">
                <h3>자주 묻는 질문</h3>
                <p class="muted"><strong>Q. 조화도 받고, ‘진심’도 받을 수 있나요?</strong><br/>A. 가능합니다. 유가족·신랑신부가 안내 문구로 선택지를 제공하면 자연스럽게 참여가 이뤄집니다.</p>
                <p class="muted"><strong>Q. 기부금은 어디로 가나요?</strong><br/>A. 파트너 공익기관으로 전달되며, 사용처와 결과는 리포트로 공유됩니다.</p>
                <p class="muted"><strong>Q. 설치가 복잡하지 않나요?</strong><br/>A. 기존 디스플레이를 활용하거나, 필요 시 전용 스탠드를 제공해 간단히 시작할 수 있습니다.</p>
            </div>
            <div class="card">
                <h3>가이드 & 리소스</h3>
                <p class="muted">현수막 문구, 모바일 안내 이미지, 디스플레이 샘플 화면, 임팩트 리포트 템플릿을 제공합니다.</p>
            </div>
            </section>

            <div class="divider"></div>

            <section id="contact" class="grid cols-2">
            <div class="card">
                <h3>도입 문의</h3>
                <p class="muted">아래 연락처로 연락주시면 24시간 내 회신드립니다.</p>
                <p class="muted">이메일: <a href="mailto:blossomlogos@naver.com" style="color:#a7f3d0;text-decoration:none">blossomlogos@naver.com</a><br/>
                연락처: <a href="tel:01038765821" style="color:#a7f3d0;text-decoration:none">010-3876-5821</a><br/>
                담당: 대표이사 김대균</p>
            </div>
            <div class="card">
                <h3>파트너십</h3>
                <p class="muted">병원·교회·NGO와의 공동 캠페인을 상시로 제안받습니다. 파일럿부터 전국 확대까지 함께 설계합니다.</p>
                <div class="chip">병원 장례식장</div>
                <div class="chip">교회 결혼예배</div>
                <div class="chip">NGO 파트너십</div>
            </div>
            </section>        

            <div class="divider"></div>
        </div>
    </main>
</template>

<script>

</script>

<style>
    .hero{display:grid; gap:18px; padding:72px 0 48px}
    .hero h1{font-size:40px; font-weight:700; line-height:1.2; margin:6px 0 10px}
    .lead{color:#596969; font-size:20px; max-width:960px}

    .grid{display:grid;gap:18px}

    @media(min-width:900px){
        .grid.cols-3{grid-template-columns:repeat(3,1fr)}
        .grid.cols-2{grid-template-columns:repeat(2,1fr)}
    }
    .card{background:linear-gradient(180deg,#0b1228,#0c142e);border:1px solid #222222;border-radius:16px;padding:18px}
    .card h3{font-size:20px; margin:6px 0 6px; color:#fff}
    .muted{color:#94a3b8}
    .chip{display:inline-flex;align-items:center;gap:8px;border:1px solid #ccc;border-radius:999px;padding:8px 12px;margin:6px 8px 0 0;color:#cbd5e1}

    .stat{display:flex;flex-direction:column;align-items:flex-start;padding:18px;border-radius:16px;background:radial-gradient(1200px 200px at -20% -50%,rgba(52,211,153,.15),transparent),#0b1228;border:1px solid #1e293b;color:#cbd5e1}
    .stat .num{font-size:36px;font-weight:800;color:#86efac}
    .divider{height:1px;background:#1f2937;margin:24px 0}
</style>